export default __webpack_public_path__ + "images/4580a030d5af134d88fe1ab7bbb1bf8f-attraction.jpg";